export default __webpack_public_path__ + "static/media/028-tramway.cf5d826c.svg";